import React from 'react';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { PipelineDesiredStatusCodes } from '@constants/pipelines';
import { setSearchPipeline } from '@redux/actions/searchActions';
import { pipelinesSelector } from '@redux/selectors/pipelineSelectors';
import { IPipeline } from '@redux/types/types';
import PipelineSelect from '@components/pipelines/PipelineSelect/PipelineSelect';

interface ISearchPipelineSelectProps {
  selectedPipeline?: IPipeline | null;
  loading?: boolean;
}

const SearchPipelineSelect = ({ selectedPipeline, loading }: ISearchPipelineSelectProps) => {
  const dispatch = useAppDispatch();
  const { data: pipelines }: { data: IPipeline[] } = useAppSelector((state) =>
    pipelinesSelector(state, PipelineDesiredStatusCodes.DEPLOYED),
  );

  const onPipelineSelect = (value: string) => {
    dispatch(setSearchPipeline(value));
  };

  return (
    <PipelineSelect
      selectedPipeline={selectedPipeline?.name}
      pipelines={pipelines}
      loading={loading}
      onPipelineSelect={onPipelineSelect}
    />
  );
};

export default SearchPipelineSelect;
